import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { IUseLng, useInfoStore } from '../../../store/userInfo';
import { useOrderStore } from '../../../store/order';
import { Box, ButtonBase, IconButton, Modal, Typography } from '@mui/material';
// import close_w from '../../../assets/images/close_w.svg';
import _ from 'lodash';
import { Axios } from '../../../api/axios';
import { useQuery } from '@tanstack/react-query';
import { loadNamespace } from '../../../locales/i18n';
import { isBrowser } from "react-device-detect";
import { useWindowDimensions } from '../../../App';
import { logger } from '../../../utils/logger';

const LazyPicture = styled(LazyLoadImage)`
  object-fit: cover;
  width: ${({ width }) => (width ? `${width}px` : "100%")};
  height: ${({ width }) => (width ? `${width}px` : "100%")};

  &.lazy-load-image-background.opacity {
    background-image: none !important;
    opacity: 0;
    transition: opacity 0.3s;
  }

  &.lazy-load-image-background.opacity.lazy-load-image-loaded {
    opacity: 1;
  }
`;

const LanguageMenu: React.FC = () => {
	const {userInfo, useLng, selectLng, setlng, setlngItem, setUseLanguage} = useInfoStore();
  const { orientation } = useWindowDimensions();
	const { openLanguageMenu, setOpenLanguageMenu} = useOrderStore();
  const storeId = userInfo?.storeId;
  const landMode = (orientation === "landscape") ?true: false

  const styles = {
    modalContent: {
      display: 'flex',
      padding: '8.3rem 6.4rem',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: landMode ? '22.6rem' : 'auto',
    }
  };

  const getLanguageSetting = async () => {
    const response = await Axios(
      { 
        method: 'GET',
        url: `/i18n/language/stores/${storeId}`
  
      })
    logger.debug(response.data)
    return response.data;
  }
  
  const { status, data } = useQuery({ 
		queryKey: [`lng-setting`, storeId], 
		queryFn: getLanguageSetting,  
		  enabled: Boolean(userInfo && Object.keys(userInfo).length !== 0),//storeId !== null, 
  })


  useEffect(() => {
    logger.debug(data)
    if(!data) return
    if(status === 'success' && data !== undefined && Array.isArray(data)) {
      setUseLanguage(data)
      if(selectLng.languageCode === "" ) {
        setlngItem(data[0])
        setlng(data[0].languageCode)
      }

      logger.debug(data)
    }
  },[data])


  const hideDialog = () => {setOpenLanguageMenu(false)}

  const  handleSelectLanguage = (item: IUseLng) => {
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
    setlngItem(item)
    setlng(item.languageCode)
    if (storeId) loadNamespace(storeId.toString());
    hideDialog()
  }
  const checkSelectLng = (item: { languageCode: string; }) => {
    if(selectLng.languageCode === item.languageCode) return true
    return false
  }
  return (
			<Modal
				// keepMounted
				disableScrollLock
				disableEnforceFocus
				hideBackdrop
				open={openLanguageMenu}
				onClose={hideDialog}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				sx={{ //You can copy the code below in your theme
					background: 'rgba(0,0,0,0.5)',
					'& .MuiBackdrop-root': {
						backgroundColor: 'transparent' // Try to remove this to see the result
					}
				}}
			>
				<Box sx={modal}>
					<Box sx={{width: '100%', height: '30%', padding: '2rem', justifyContent: 'center', flexDirection: 'column', alignItems: 'flex-start', gap: '1.0rem', backgroundColor: '#f00', borderRadius: '1.5rem 1.5rem 0rem 0rem'}}>
						<Typography sx={{textAlign: 'center', fontSize: '3rem', fontStyle: 'normal', fontWeight: '900', lineHeight: '150%', letterSpacing: '.15rem', color: '#fff'}}>Language</Typography>
						<Typography sx={{textAlign: 'center', fontSize: '1.8rem', fontStyle: 'normal', fontWeight: '500', lineHeight: '150%', color: '#fff', textWrap: 'nowrap',}}>Choosing your preferred language will translate automatically.</Typography>
					</Box>
          <div className="touch-area" style={{position: 'absolute',  right: '3.0rem', top: '1.4rem',}}  onClick={hideDialog}>
            <IconButton
              aria-label="close"
            >
              <LazyPicture style={{width: '3rem', height: '3rem'}}
                src={process.env.PUBLIC_URL+'/assets/images/close_w.svg'}
                alt="close"
              />
            </IconButton>
          </div>
					<Box sx={styles.modalContent}>
						<Box sx={{display: 'flex', flexDirection: landMode ?'row': 'column', gap: '4rem'}}>
              {useLng.map((item) => {
                return( 
                   <ButtonBase sx={[{width : '20.8rem', height: '6.0rem', padding: '1.0rem 1.4rem', justifyContent: 'center', alignItems: 'center', borderRadius: '5px', border: '1.5px solid #000'},
                    checkSelectLng(item)? {background: '#000'}: {background: '#fff'}]}  onClick={() => handleSelectLanguage(item)}>
                    <Typography sx={[{fontSize: '2.0rem', fontStyle: 'normal', fontWeight: '500', lineHeight: 'normal'}, checkSelectLng(item)? {color: '#fff'}: {color: '#000'}]}>{item.languageName}</Typography>
                  </ButtonBase>
                )
              })}

            </Box>
					</Box>
				</Box>
			</Modal>
  );
}
const modal = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  // height: '100%',
  bgcolor: 'background.paper',
  // border: '2px solid #fff',
	borderRadius: '1.5rem',
  boxShadow: '0px 0px 50px 0px rgba(0, 0, 0, 0.40)'

};

export default LanguageMenu;
